export default __webpack_public_path__ + "static/media/ira_light.647d23ad.png";